export function convertFileName(fileName: string): string {
	return fileName.replace('.html', '.md');
}
